module.exports = __webpack_public_path__ + "static/illustration-lg-d43b91a13cf10cbfb9d3710dc9470d3e.png";